export const convertPageNameToPath = (pageName: string) => {
  return pageName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};
